export const labelColor = "#FFFFFF";

export const stateStroke = "#888888";

export const farmNeutralFill = "#CCCCCC";
export const farmNeutralStroke = "#AAAAAA";
export const farmHighlightStroke = "#777777";

export const farmInfectedFill = "#FF5555";
export const farmInfectedStroke = "#FF0000";

export const farmRadiusStroke = "#E8C051";

export const plumeFill = "#D2C3A7";
// export const plumeFill = "#E3DAC9";
// export const plumeFill = "#D27C14";
// export const plumeFill = "#AAAAAA";
// export const plumeFill = "#9ebcda";
// export const plumeFill = "#f1d7b8";
